module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Medium.f50002bc.woff";